import { FormPlayer } from '@/components/FormPlayer/FormPlayer'
import type { FormPreviewSnapshot } from '@/contracts/form-preview'
import type { PublicForm } from '@/types/form'
import { useMemo } from 'react'

export function PreviewPlayerAdapter({
  snapshot,
  showOnePageSubmitBar = true,
}: {
  snapshot: FormPreviewSnapshot
  showOnePageSubmitBar?: boolean
}) {
  const initialPhase = snapshot.steps.some((step) => step.kind === 'welcome')
    ? 'welcome'
    : 'questions'
  const form = useMemo(
    () =>
      ({
        ...snapshot.form,
        groups: snapshot.groups,
      }) as PublicForm & { groups: typeof snapshot.groups },
    [snapshot],
  )

  return (
    <div className="h-full min-h-full bg-slate-100" data-testid="preview-player-adapter">
      <FormPlayer
        form={form}
        mode="preview"
        initialPhase={initialPhase}
        showOnePageSubmitBar={showOnePageSubmitBar}
      />
    </div>
  )
}
